import { api } from "@/lib/axios";
import type { LoginRequest, LoginResponse } from "../types/auth.types";

export const login = async (
  credentials: LoginRequest,
): Promise<LoginResponse> => {
  const { data } = await api.post<LoginResponse>(
    "/api/Login/SignIn",
    credentials,
  );
  return data;
};
